import React, { useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import { FiUserPlus, FiUser, FiPhone, FiHash, FiCheckCircle } from "react-icons/fi";

const AddWorker = () => {
  const [formData, setFormData] = useState({
    worker_id: "",
    name: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      // API call to HOD route
      const res = await API.post("/hod/add-worker", formData);
      if (res.data.success) {
        setMessage({ type: "success", text: "Worker added to your department! 🎉" });
        setFormData({ worker_id: "", name: "", phone: "" });
      }
    } catch (err) {
      setMessage({ type: "error", text: err.response?.data?.message || "Failed to add worker" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.layout}>
      <Sidebar />
      <div style={styles.mainContent}>
        <div style={styles.header}>
          <h2 style={styles.title}>Register New Worker 👷‍♂️</h2>
          <p style={styles.subtitle}>Onboard staff to your department for ticket assignment.</p>
        </div>

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div style={styles.iconCircle}><FiUserPlus /></div>
            <h3 style={styles.cardTitle}>Worker Details</h3>
          </div>

          <form onSubmit={handleSubmit} style={styles.form}>
            {/* WORKER ID */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Worker ID / Badge No.</label>
              <div style={styles.inputWrapper}>
                <FiHash style={styles.inputIcon} />
                <input
                  type="text"
                  name="worker_id"
                  placeholder="e.g. W-101"
                  value={formData.worker_id}
                  onChange={handleChange}
                  style={styles.input}
                  required
                />
              </div>
            </div>

            {/* FULL NAME */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Full Name</label>
              <div style={styles.inputWrapper}>
                <FiUser style={styles.inputIcon} />
                <input
                  type="text"
                  name="name"
                  placeholder="Enter worker's full name"
                  value={formData.name}
                  onChange={handleChange}
                  style={styles.input}
                  required
                />
              </div>
            </div>

            {/* PHONE NUMBER */}
            <div style={styles.inputGroup}>
              <label style={styles.label}>Phone Number</label>
              <div style={styles.inputWrapper}>
                <FiPhone style={styles.inputIcon} />
                <input
                  type="text"
                  name="phone"
                  placeholder="Enter phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  style={styles.input}
                />
              </div>
            </div>

            {message.text && (
              <div style={{ ...styles.msg, color: message.type === "success" ? "#10B981" : "#EF4444" }}>
                {message.type === "success" && <FiCheckCircle style={{marginRight: '8px'}} />}
                {message.text}
              </div>
            )}

            <button type="submit" disabled={loading} style={styles.button}>
              {loading ? "Registering..." : "CONFIRM & ADD WORKER"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

/* --- STYLES --- */
const styles = {
  layout: { display: "flex", background: "#F8FAFC", minHeight: "100vh" },
  mainContent: { marginLeft: "260px", padding: "40px", flex: 1, fontFamily: "'Poppins', sans-serif" },
  header: { marginBottom: "30px" },
  title: { margin: 0, fontSize: "26px", fontWeight: "700", color: "#1E293B" },
  subtitle: { color: "#64748B", fontSize: "14px", marginTop: "5px" },
  card: {
    background: "#FFFFFF",
    padding: "35px",
    borderRadius: "20px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.02)",
    border: "1px solid #F1F5F9",
    maxWidth: "500px",
  },
  cardHeader: { display: "flex", alignItems: "center", gap: "12px", marginBottom: "25px" },
  iconCircle: { width: "40px", height: "40px", borderRadius: "10px", background: "#FFFBEB", color: "#D4AF37", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px" },
  cardTitle: { margin: 0, fontSize: "18px", fontWeight: "600", color: "#1E293B" },
  form: { display: "flex", flexDirection: "column", gap: "18px" },
  inputGroup: { display: "flex", flexDirection: "column", gap: "6px" },
  label: { fontSize: "13px", fontWeight: "600", color: "#64748B" },
  inputWrapper: { position: "relative", display: "flex", alignItems: "center" },
  inputIcon: { position: "absolute", left: "15px", color: "#D4AF37" },
  input: {
    width: "100%",
    padding: "12px 15px 12px 42px",
    background: "#F8FAFC",
    border: "1px solid #E2E8F0",
    borderRadius: "12px",
    fontSize: "14px",
    outline: "none",
  },
  button: {
    background: "#D4AF37",
    color: "#000",
    border: "none",
    padding: "14px",
    borderRadius: "12px",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "10px",
    boxShadow: "0 8px 15px rgba(212, 175, 55, 0.2)",
  },
  msg: { fontSize: "13px", fontWeight: "500", marginTop: "5px", display: 'flex', alignItems: 'center' }
};

export default AddWorker;